<div class="page-header">
    <div class="col-12">
        <h1>Scheduling <small>View job and task priorities across jobs and departments</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged($event)" class="nav-tabs">
        <li [ngbNavItem]="0">
            <a ngbNavLink>Job Priorities</a>
        </li>
        <li [ngbNavItem]="-2">
            <a ngbNavLink>Job Phases</a>
        </li>
        <li [ngbNavItem]="-3">
            <a ngbNavLink>Job Tasks</a>
        </li>
        <li [ngbNavItem]="15">
            <a ngbNavLink>Concrete</a>
        </li>
        <li [ngbNavItem]="10">
            <a ngbNavLink>Pipe</a>
        </li>
        <li [ngbNavItem]="11">
            <a ngbNavLink>Earth Work</a>
        </li>
        <li [ngbNavItem]="12">
            <a ngbNavLink>Finishes</a>
        </li>
        <li [ngbNavItem]="55">
            <a ngbNavLink>Mechanical</a>
        </li>
        <li [ngbNavItem]="40">
            <a ngbNavLink>Drivers</a>
        </li>
        <li [ngbNavItem]="45">
            <a ngbNavLink>Survey</a>
        </li>
        <li [ngbNavItem]="20">
            <a ngbNavLink>Fabrication</a>
        </li>
        <li [ngbNavItem]="1000">
            <a ngbNavLink>Misc</a>
        </li>
        <li [ngbNavItem]="1001">
            <a ngbNavLink>Vac Truck</a>
        </li>
        <li [ngbNavItem]="1002">
            <a ngbNavLink>Boom Truck</a>
        </li>
        <li [ngbNavItem]="-4">
            <a ngbNavLink>Transport</a>
        </li>
        <li [ngbNavItem]="-1">
            <a ngbNavLink>Phase Data</a>
        </li>
    </ul>
    <div class="row" style="margin-top: 10px" [hidden]="activeTab !== 0">
        <h5>Active Jobs listed by priority and active departments</h5>
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <select
                            name="sortMode"
                            class="form-select form-select-sm"
                            style="width: auto; margin-left: 10px"
                            [(ngModel)]="sortMode"
                            (ngModelChange)="onSortModeChanged()"
                        >
                            @for (option of sortModeOptions; track option.value) {
                                <option [ngValue]="option.value">{{ option.display }}</option>
                            }
                        </select>
                        <grid-export [grid]="mainGrid" [name]="'Job Scheduling'"></grid-export>
                    </form>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <grid-column-group [grid]="grid"></grid-column-group>
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemFormatter]="mainGridItemFormatter"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemsSource]="grid.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="2"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Priority'"
                            [binding]="'priority'"
                            [dataMap]="jobPriorityMap"
                            [width]="100"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobName'" [width]="400" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Division'"
                            [binding]="'divisionName'"
                            [width]="180"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Start'"
                            [binding]="'start'"
                            [width]="120"
                            [format]="'d'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contract End'"
                            [binding]="'end'"
                            [width]="120"
                            [format]="'d'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Proj End'"
                            [binding]="'projectedEnd'"
                            [width]="120"
                            [format]="'d'"
                            [editor]="inputDate"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Milestone'"
                            [binding]="'milestone'"
                            [width]="120"
                            [format]="'d'"
                            [editor]="inputDate"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Reason'"
                            [binding]="'reason'"
                            [width]="200"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Priority Department(s)'" [binding]="'departmentList'" [width]="350">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <span>
                                    {{ getCellValue(cell) }}
                                </span>
                            </ng-template>
                            <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                <wj-multi-select
                                    #templateMultiSelect
                                    style="width: 100%; border-radius: 0"
                                    [isRequired]="false"
                                    [itemsSource]="departmentOptions"
                                    (checkedItemsChanged)="checkChanged(templateMultiSelect, cell)"
                                    (itemsSourceChanged)="itemsSourceChanged(templateMultiSelect, cell)"
                                    [(checkedItems)]="cell.item.departmentList"
                                    [displayMemberPath]="'value'"
                                >
                                </wj-multi-select>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Liquidated Damage'"
                            [binding]="'liquidatedDamage'"
                            [width]="130"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Chad Wants'"
                            [binding]="'notes'"
                            [width]="'*'"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 10px" [hidden]="activeTab !== -2">
        <h5>Select a job below to see its phases. Click on the navigate button for directions to the selected job.</h5>
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="jobPhaseGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="jobPhaseGrid.filter"></action-toolbar-search>
                        <grid-export [grid]="gridJobPhase" [name]="'Job Scheduling'"></grid-export>
                        <wj-auto-complete
                            [(ngModel)]="selectedJob"
                            name="job"
                            [isRequired]="false"
                            style="width: 400px"
                            (ngModelChange)="jobChanged()"
                            [maxItems]="100"
                            [itemsSource]="jobOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-auto-complete>
                        <button class="btn btn-sm btn-secondary" (click)="navigate()">
                            <fa-icon class="d-none d-sm-inline-block" [icon]="faMap"></fa-icon> Navigate ({{ addressString }})
                        </button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridJobPhase"
                        #gridJobPhase
                        appAutoSize
                        (initialized)="jobPhaseGrid.initialize(gridJobPhase)"
                        (destroy)="jobPhaseGrid.destroy()"
                        [itemsSource]="jobPhaseGrid.view"
                        [keyActionTab]="'CycleEditable'"
                        [itemFormatter]="jobPhaseGridItemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <!--<wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="100"></wj-flex-grid-column>-->
                        <wj-flex-grid-column [header]="'Phase'" [binding]="'phase'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Active'" [binding]="'isActive'" [width]="100"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Cost Types'" [binding]="'costTypes'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'2*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 10px" [hidden]="activeTab < 1 && activeTab !== -3">
        <h5>Department tasks and their priorities</h5>
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="taskGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="taskGrid.filter"></action-toolbar-search>
                        <action-toolbar-buttons
                            [grid]="taskGrid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <grid-export [grid]="gridTask" [name]="'Bid History'"></grid-export>
                    </form>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridTask"
                        #gridTask
                        appAutoSize
                        (initialized)="taskGrid.initialize(gridTask)"
                        [itemsSource]="taskGrid.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="3"
                        (cellEditEnded)="cellEditEnded(gridTask, $event)"
                        (pasting)="pasting(gridTask, $event)"
                        (pasted)="pasted(gridTask, $event)"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Job Priority'"
                            [binding]="'jobPriority'"
                            [dataMap]="jobPriorityMap"
                            [width]="90"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Task Priority'"
                            [binding]="'priority'"
                            [dataMap]="priorityMap"
                            [width]="90"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Phase Priority'"
                            [binding]="'phasePriority'"
                            [dataMap]="priorityMap"
                            [width]="90"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Dept'"
                            [binding]="'departmentId'"
                            [dataMap]="departmentMap"
                            [width]="110"
                            [isReadOnly]="true"
                            [visible]="activeTab === -3"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job'"
                            [binding]="'job'"
                            [width]="230"
                            [isReadOnly]="true"
                            [dataMap]="jobMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Task Number'" [binding]="'indexId'" [width]="100"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Task'" [binding]="'name'" [width]="225"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Est Start Date'"
                            [binding]="'estimatedStartDate'"
                            [width]="150"
                            [format]="'MMMM yyyy'"
                            [editor]="inputDateMonth"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Est Hours'"
                            [binding]="'estimatedHours'"
                            [width]="150"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Crew Assignment'"
                            [binding]="'crewAssignment'"
                            [width]="200"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Site Ready'" [binding]="'siteReady'" [width]="80"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Materials Ready'" [binding]="'materialsReady'" [width]="120"></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Predecessor Task (coming soon)'" [binding]="'predecessor'" [width]="300"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Site Super  (coming soon)'" [binding]="'siteSuper'" [width]="250"></wj-flex-grid-column>-->
                        <wj-flex-grid-column
                            [header]="'Materials Needed'"
                            [binding]="'materialsNeeded'"
                            [width]="'*'"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <wj-input-date #inputDateMonth [isRequired]="false" [selectionMode]="'Month'"></wj-input-date>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 10px" [hidden]="activeTab !== -1">
        <h5>Raw Phase Data</h5>
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="phaseGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="phaseGrid.filter"></action-toolbar-search>
                        <action-toolbar-buttons
                            [grid]="phaseGrid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <grid-export [grid]="gridPhase" [name]="'Bid History'"></grid-export>
                    </form>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridPhase"
                        #gridPhase
                        appAutoSize
                        (initialized)="phaseGrid.initialize(gridPhase)"
                        [itemsSource]="phaseGrid.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="2"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <app-scheduling-transports [jobs]="jobs" [active]="activeTab" [hidden]="activeTab !== -4"></app-scheduling-transports>
</div>
